import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const TikTok = (props: any) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.18a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.61z"/></svg>
);

export const Footer = () => (
  <footer className="bg-ink pt-16 pb-28 md:pb-8 text-white/85">
    <div className="container">
      <div className="grid gap-10 md:grid-cols-4">
        <div>
          <Logo light />
          <p className="mt-4 text-sm">Edmonton's only garage specialist. Cleanouts, cash, and complete transformations.</p>
        </div>
        <div>
          <h3 className="font-display text-lg tracking-wide text-white">Navigate</h3>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/#services" className="hover:text-gold">Services</Link></li>
            <li><Link to="/#how" className="hover:text-gold">How It Works</Link></li>
            <li><Link to="/#partners" className="hover:text-gold">Partner Network</Link></li>
            <li><Link to="/epoxy-flooring" className="hover:text-gold">Epoxy Flooring</Link></li>
            <li><Link to="/#about" className="hover:text-gold">About</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-lg tracking-wide text-white">Contact</h3>
          <ul className="mt-3 space-y-2 text-sm">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-gold" /> <a href="tel:+15874073024" className="hover:text-gold">+1 (587) 407-3024</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-gold" /> <a href="mailto:contact@garagekingsyeg.com" className="hover:text-gold">contact@garagekingsyeg.com</a></li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-gold" /> Edmonton, AB</li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-lg tracking-wide text-white">Follow @garagekingsyeg</h3>
          <div className="mt-3 flex gap-3">
            {[
              { Icon: Instagram, url: "https://www.instagram.com/garagekingsyeg/", label: "Instagram" },
              { Icon: TikTok, url: "https://www.tiktok.com/@garagekingsyeg", label: "TikTok" },
            ].map(({ Icon, url, label }, i) => (
              <a
                key={i}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Follow Garage Kings YEG on ${label}`}
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/20 hover:border-gold hover:text-gold"
              >
                <Icon className="h-5 w-5" aria-hidden="true" />
                <span className="sr-only">{label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-12 border-t border-white/10 pt-6 text-center">
        <p className="font-display text-2xl tracking-[0.3em] text-gold">CLEAN OUT. CASH OUT. LEVEL UP.</p>
        <p className="mt-3 text-xs text-white">© 2026 Garage Kings. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
